import styled, { css } from 'styled-components';

import { mixins } from '#@/shared/utils/styles';

export const Wrapper = styled.div`
  display: flex;
  height: fit-content;
  width: 100%;
  overflow: hidden;
`;

export const TruncatedText = styled.span<{ $multiline?: boolean }>`
  width: 100%;
  ${({ $multiline }) =>
    mixins.truncateText(
      $multiline
        ? css`
            white-space: normal;
          `
        : undefined,
    )};
`;
